import store from '~/store'

export default (to, from, next) => {
  if (store.getters['auth/check'] && store.getters['auth/token']) {
    next({ name: 'dashboard' })
  } else {
    next()
  }
}
